import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/user_research.png";
import { StaticImage } from "gatsby-plugin-image";

const Userresearchyeppy = () => {
  return (
    <div
      className="userresearch_yeppy p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
            <h2>User Research</h2>
            <p>
              User research is a systematic process aimed at uncovering the
              user's perspective, their pain points, and the challenges they
              face in order to gain a comprehensive understanding of their
              experiences and needs. It encompasses the gathering and
              examination of user data using a range of methods, including
              surveys, interviews, and usability testing.
            </p>
          </Col>
          <Col xs={12} md={6} lg={8} xl={8} xxl={8}>
            <div className="research_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/user_girl.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1060}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Userresearchyeppy;
